import { onError } from "@apollo/client/link/error";
import { logout } from "../utils/logout";

/**
 * Apollo error link to handle authentication errors
 * Automatically logs out user and redirects to login on 401 responses
 */
export const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path, extensions }) => {
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        );

        // Check if the error is a 401 authentication error
        if (
          extensions?.code === "UNAUTHENTICATED" ||
          extensions?.status === 401 ||
          message?.includes("401") ||
          message?.includes("Unauthorized")
        ) {
          console.log("Authentication error detected, logging out user");
          logout();
        }
      });
    }

    if (networkError) {
      console.log(`[Network error]: ${networkError}`);

      // Check if the network error is a 401
      if (
        networkError.statusCode === 401 ||
        networkError.message?.includes("401") ||
        networkError.message?.includes("Unauthorized")
      ) {
        console.log("Network authentication error detected, logging out user");
        logout();
      }
    }
  }
);
